var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-tolltip"},[(_vm.textLabel)?_c('ContentChip',{attrs:{"color":_vm.color,"leading-icon":_vm.leadingIcon,"text-label":_vm.textLabel,"leading-img":_vm.leadingImg}}):_vm._e(),(_vm.tooltipContent)?_c('div',{staticClass:"chip-tolltip-tooltip"},[_c('p',[_vm._v(_vm._s(_vm.tooltipContent))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }